import React from 'react';
import { motion } from 'framer-motion';
export function UMPSection() {
  return <section className="py-16 md:py-24 px-5 md:px-8" data-id="element-143">
      <div className="max-w-4xl mx-auto" data-id="element-144">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-145">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6" data-id="element-146">
            Por qué lo que has intentado{' '}
            <span className="text-red-400" data-id="element-147">NO funcionó</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 mb-20" data-id="element-148">
          {["Los tapones de espuma eliminan el ruido ambiental, obligando al cerebro a subir su 'volumen interno' y amplificar el zumbido.", 'Las apps de ruido blanco genérico usan frecuencias agudas que estresan el nervio auditivo en lugar de relajarlo.', "Intentar 'meditar' en el silencio absoluto es imposible cuando tu cerebro interpreta el pitido como una señal de peligro inminente.", "Los suplementos 'milagrosos' no funcionan porque el problema no es una falta de vitaminas, sino un error de procesamiento en tu núcleo coclear."].map((text, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-[#1a1f3a] p-6 rounded-xl border border-[#2a3150] flex gap-4" data-id="element-149">
              <div className="text-red-400 font-bold text-xl mt-1" data-id="element-150">✕</div>
              <p className="text-gray-300 leading-relaxed" data-id="element-151">{text}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-[#1a1f3a] to-[#0a0e1a] p-8 md:p-12 rounded-2xl border border-[#d4a853]/30 shadow-[0_0_30px_rgba(212,168,83,0.1)] relative overflow-hidden" data-id="element-152">
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#d4a853] rounded-full blur-[100px] opacity-10 pointer-events-none" data-id="element-153"></div>

          <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#d4a853] mb-6 text-center" data-id="element-154">
            El Mecanismo Único: Habituación Selectiva Nocturna
          </h2>

          <div className="space-y-6 text-gray-300 text-lg leading-relaxed" data-id="element-155">
            <p data-id="element-156">
              La clave de la recuperación no es eliminar el sonido (que es
              eléctrico), sino lograr la{' '}
              <strong className="text-white" data-id="element-157">
                Habituación Selectiva Nocturna
              </strong>
              .
            </p>
            <p data-id="element-158">
              Mediante el uso del <strong data-id="element-159">Interruptor del Nervio Vago</strong>,
              enviamos una señal mecánica directa al cerebro para que deje de
              clasificar el zumbido como una amenaza.
            </p>
            <p data-id="element-160">
              Al combinar esto con el{' '}
              <strong data-id="element-161">Enmascaramiento Natural Progresivo</strong>, entrenamos a
              tus neuronas para que envíen el ruido a la "papelera de reciclaje"
              mental, permitiéndote caer en un sueño profundo en menos de 15
              minutos, incluso si el zumbido sigue ahí.
            </p>
          </div>

          <div className="mt-10 flex justify-center" data-id="element-162">
            <a href="#comprar" className="bg-[#d4a853] hover:bg-[#e5b964] text-[#0a0e1a] font-bold text-lg px-8 py-3.5 rounded-lg transition-all duration-300 shadow-[0_0_20px_rgba(212,168,83,0.3)] transform hover:scale-105 active:scale-95 flex items-center justify-center w-full md:w-auto" data-id="element-163">
              Ver Protocolo
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}